
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/main-logo.svg'
import { Routes } from '../../constants/RouteConstants';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from '../../components/ui/Button';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import toast from 'react-hot-toast';
import ContactUsValidation from '../../validations/auth/ContactUsValidation';
import TopHeader from '../../components/layouts/TopHeader';
import PageLayout from '../../components/ui/PageLayout';

interface FormInputs {
  email: string;
  name: string;
  subject: string;
  description?: string;
};


const ContactUs = () => {

  const contactUs = useMakeRequest();
  const { register, reset, formState: { errors }, handleSubmit } = useForm<FormInputs>({
    mode: 'onChange',
    resolver: yupResolver(ContactUsValidation),
  });

  const onSubmit = (formInputs: FormInputs) => {
    toast.promise(
      contactUs.makeRequest({ url: ApiConstants?.ContactUs, payload: formInputs }),
      {
        loading: 'Processing...',
        success: (data: any) => data.message,
        error: (error: any) => error.message,
      }
    )
  }

  useEffect(() => {
    if (contactUs?.status) {
      reset()
    }
  }, [contactUs?.status])
  return (
    <PageLayout headerName={"Contact Us"} onlyTitle={false}>
      <div className="page-padding-x">
        <div className="auth-container">
          <form className='auth-form-wrap' onSubmit={handleSubmit(onSubmit)}>
            <div className="auth-form-fields">
              <div className="com-input-grp">
                <label className="form-label" htmlFor="contact_email">Email<span className='label-star'>*</span></label>
                <input
                  id="contact_email"
                  {...register('email')}
                  className={`form-control ${errors?.email ? 'is-invalid' : ''}`}
                  placeholder='Enter email'
                  aria-invalid={!!errors?.email}
                  aria-describedby={errors?.email ? "contact_email-error" : undefined}
                />
                <ErrorMessage
                  errors={errors}
                  name="email"
                  render={({ message }) => <p id="contact_email-error" className='valid-error' tabIndex={0} role="alert" aria-live="polite">{message}</p>}
                />
              </div>
              <div className="com-input-grp">
                <label className="form-label" htmlFor="contact_name">Name<span className='label-star'>*</span></label>
                <input
                  id="contact_name"
                  {...register('name')}
                  className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
                  placeholder='Enter name'
                  aria-invalid={!!errors?.name}
                  aria-describedby={errors?.name ? "contact_name-error" : undefined}
                />
                <ErrorMessage
                  errors={errors}
                  name="name"
                  render={({ message }) => <p id="contact_name-error" className='valid-error' tabIndex={0} role="alert" aria-live="polite">{message}</p>}
                />
              </div>
              <div className="com-input-grp">
                <label className="form-label" htmlFor="contact_subject">Subject<span className='label-star'>*</span></label>
                <input
                  id="contact_subject"
                  {...register('subject')}
                  className={`form-control ${errors?.subject ? 'is-invalid' : ''}`}
                  placeholder='Enter subject'
                  aria-invalid={!!errors?.subject}
                  aria-describedby={errors?.subject ? "contact_subject-error" : undefined}
                />
                <ErrorMessage
                  errors={errors}
                  name="subject"
                  render={({ message }) => <p id="contact_subject-error" className='valid-error' tabIndex={0} role="alert" aria-live="polite">{message}</p>}
                />
              </div>

              <div className="com-input-grp">
                <label className="form-label text-gray-700 font-medium mb-2 block" htmlFor="contact_description">
                  Description
                </label>
                <textarea
                  id="contact_description"
                  className={`form-control-rounded ${errors?.description ? 'is-invalid' : ''}`}
                  rows={5}
                  placeholder='How can we help?'
                  aria-invalid={!!errors?.description}
                  aria-describedby={errors?.description ? "contact_description-error" : undefined}
                  {...register('description')}
                ></textarea>
                <ErrorMessage
                  errors={errors}
                  name="description"
                  render={({ message }) => <p id="contact_description-error" className='valid-error text-red-500 text-sm mt-1' tabIndex={0} role="alert" aria-live="polite">{message}</p>}
                />
              </div>
            </div>
            <Button className='com-btn my-5' type='submit' loading={contactUs?.loading}>Submit</Button>
          </form>
        </div>
      </div>
    </PageLayout>
  )
}

export default ContactUs;